import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { useState, useRef, useEffect } from "react";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import { useOutletContext } from "react-router-dom";
import { SELECTBUTTON_OPTIONS } from "../../exerciseDefaults";


const AddExercisesWizardSection = ({
    t,
    isPanelsSectionSelected,
    handleSelectButton,
    onHideDialog,
    days,
    selectedPatient,
    handleDelete,
    handleCarePlanName,
    carePlanName,
    setCarePlanName,
    dateOfStart,
    dateOfEnd,
    handleDateOfStart,
    handleDateOfEnd,
    handleApprovePrescription,
    selectedExercises,
    setSelectedExercises,
    isPendingAddPlan,
    setExerciseVideoDialogVisible,
    setSelectedExerciseForVideo
}: any) => {
    const { systemPanels }: any = useOutletContext();

    const [panels, setPanels] = useState([]);

    const [step, setStep] = useState<number>(1);
    const gridContainerRef = useRef<HTMLDivElement>(null);
    const figureContainerRef = useRef<HTMLDivElement>(null);

    const [selectedFigures, setSelectedFigures] = useState<any[]>([]);
    const [selectedFiguresForFilter, setSelectedFiguresForFilter] = useState<any[]>([]);

    const [selectedIllnessList, setSelectedIllnessList] = useState<any>([]);

    const [clickedPanels, setClickedPanels] = useState<any>([]);
    const [selectedPanels, setSelectedPanels] = useState<any>([]);
    const [manuelSelectedExercises, setManuelSelectedExercises] = useState<any[]>([]);

    const [activePanelIndex, setActivePanelIndex] = useState(-1);

    const [applyButtonVisibleFirstStep, setApplyButtonVisibleFirstStep] = useState<any>(true);
    const [applyButtonVisibleSecondStep, setApplyButtonVisibleSecondStep] = useState<any>(true);

    const [isEditModeActive, setIsEditModeActive] = useState<boolean>(false);
    const [editedExercises, setEditedExercises] = useState<any[]>([]);
    const [isCollapsedDetails, setIsCollapsedDetails] = useState<boolean>(false);

    const [isNextButtonDisabled, setIsNextButtonDisabled] = useState<boolean>(true);

    useEffect(() => {
        if (step === 1 || step === 2 || step === 3 || step === 4) {
            const resizeEvent = new Event('resize');
            window.dispatchEvent(resizeEvent);

            const timeoutId = setTimeout(() => {
                const resizeEvent2 = new Event('resize');
                window.dispatchEvent(resizeEvent2);

                if (figureContainerRef.current) {
                    const width = figureContainerRef.current.offsetWidth;
                    const height = figureContainerRef.current.offsetHeight;

                    void width;
                    void height;
                }
                if (gridContainerRef.current) {
                    void gridContainerRef.current.offsetWidth;
                }
            }, 450);

            return () => clearTimeout(timeoutId);
        }
    }, [step]);

    const filterPanel = (panel:any) => {
        const matchFigure = selectedFiguresForFilter.length === 0 ||
            panel.bodyParts?.some((bp: string) =>
                selectedFiguresForFilter.includes(bp)
            );

        const matchIllness = selectedIllnessList.length === 0 ||
            panel.illnesses?.some((ill: string) =>
                selectedIllnessList.includes(ill)
            );

        return matchFigure && matchIllness;
    }


    const applyPanelsFilter = () => {
        const _panels = systemPanels.filter((panel: any) => {
            return filterPanel(panel);
        });
        
        const _selectedPanels = selectedPanels.filter((panel: any) => {
            return filterPanel(panel);
        });
        
        const _manuelSelectedExercises = manuelSelectedExercises?.filter((manuelEx: any) => {
            const exerciseId = manuelEx?.exercise?.id;
            
            const panelsContainingExercise = systemPanels.filter((panel: any) => 
                panel?.exerciseProcedure?.some((ep: any) => ep.procedureId === exerciseId)
            );
            
            if (panelsContainingExercise.length === 0) {
                return true;
            }
            
            return panelsContainingExercise.some((panel: any) => filterPanel(panel));
        }) ?? [];
        
        const allSelectedExerciseIds = new Set<any>();
        
        for (const panel of _selectedPanels) {
            for (const ep of panel?.exerciseProcedure ?? []) {
                allSelectedExerciseIds.add(ep?.procedureId);
            }
        }
        
        for (const manuelEx of _manuelSelectedExercises) {
            allSelectedExerciseIds.add(manuelEx?.exercise?.id);
        }
        
        const selectedPanelIds = new Set(_selectedPanels.map((p: any) => p.id));
        
        const completedPanels = _panels.filter((panel: any) => {
            if (selectedPanelIds.has(panel.id)) {
                return false;
            }
            
            const panelExerciseIds = panel?.exerciseProcedure?.map(
                (ep: any) => ep.procedureId
            ) ?? [];
            
            if (panelExerciseIds.length === 0) {
                return false;
            }
            
            return panelExerciseIds.every((id: any) =>
                allSelectedExerciseIds.has(id)
            );
        });
        
        setPanels(_panels);
        setSelectedPanels([..._selectedPanels, ...completedPanels]);
        setManuelSelectedExercises(_manuelSelectedExercises);
    }

    const deleteExerciseOverride = (exercise:any) => {
        const deletedExerciseId = exercise?.exercise?.id;
        if (!deletedExerciseId) {
            handleDelete(exercise);
            return;
        }
        
        const affectedPanels = selectedPanels.filter((panel: any) =>
            panel.exerciseProcedure?.some(
                (ep: any) => ep.procedureId === deletedExerciseId
            )
        );
        
        if (affectedPanels.length > 0) {
            setSelectedPanels((prev: any) =>
                prev.filter((p: any) => !affectedPanels.some((ap: any) => ap.id === p.id))
            );
            
            const allRemainingPurified: any[] = [];
            for (const affectedPanel of affectedPanels) {
                const remainingExercises = affectedPanel.exerciseProcedure.filter(
                    (ep: any) => ep.procedureId !== deletedExerciseId
                );
                
                if (remainingExercises.length > 0) {
                    const purified = remainingExercises.map((ep: any) => ({
                        exercise: { id: ep.procedureId },
                        ...ep
                    }));
                    allRemainingPurified.push(...purified);
                }
            }
            
            setManuelSelectedExercises((prev: any) => {
                const withoutDeleted = prev.filter(
                    (m: any) => m.exercise.id !== deletedExerciseId
                );
                
                const existingIds = new Set(withoutDeleted.map((m: any) => m.exercise.id));
                
                return [
                    ...withoutDeleted,
                    ...allRemainingPurified.filter(
                        (p: any) => !existingIds.has(p.exercise.id)
                    ),
                ];
            });
        } else {
            setManuelSelectedExercises((prev: any) =>
                prev.filter((m: any) => m.exercise.id !== deletedExerciseId)
            );
        }
        
        handleDelete(exercise);
    }

    const selectButtonTemplate = (option: any) => {
        const img = option.name === "panels" ? "/panels-menu-img-<color>.svg" : "/wizard-menu-img-<color>.svg";
        const imgSrc = isPanelsSectionSelected ? img.replace("<color>", "white") : img.replace("<color>", "gray");
        return (
            <div className="flex align-items-center gap-2">
                <img src={imgSrc} alt={option.name} width={25} />
                <span>{t(option.name)}</span>
            </div>
        );
    }

    const prevClick = () => {
        if(step === 3) {
            setIsEditModeActive(false);
        }
        setSelectedExercises([]);
        setStep(prev => prev - 1);
    }

    const nextClick = () => {
        if(step === 3) {
            setIsEditModeActive(false);
        }
        setSelectedExercises([]);
        setStep(prev => prev + 1);
    }

    useEffect(() => {
        if(step === 3) {
            setIsNextButtonDisabled(true)
        } else if(step === 1) {
            setIsNextButtonDisabled(applyButtonVisibleFirstStep)
        } else if(step === 2) {
            setIsNextButtonDisabled(applyButtonVisibleSecondStep)
        } else if(step === 4) {
            setIsNextButtonDisabled(true)
        }
    }, [step, applyButtonVisibleFirstStep, applyButtonVisibleSecondStep])

    useEffect(() => {
        applyPanelsFilter();
    }, [selectedFiguresForFilter])

    return (
        <div className="flex flex-column p-4 gap-4" style={{ height: "100%" }}>
            <div className="flex justify-content-between align-items-center">
                <SelectButton allowEmpty={false} options={SELECTBUTTON_OPTIONS} itemTemplate={selectButtonTemplate} optionLabel="name" optionValue="value" className="exercises-or-panels-select-button flex gap-3" value={isPanelsSectionSelected} onChange={handleSelectButton} />
                <div className="flex justify-content-end align-items-center gap-4">
                    <div className="flex align-items-center gap-1">
                        <Button disabled={step === 1} onClick={prevClick} className="w-2rem h-2rem" style={{ color: "#FFFFFF", backgroundColor: "#2D3967" }} icon="pi pi-angle-left" outlined rounded aria-label="Delete" />
                        <Button disabled={isNextButtonDisabled} onClick={nextClick} className="w-2rem h-2rem" style={{ color: "#FFFFFF", backgroundColor: "#2D3967" }} icon="pi pi-angle-right" outlined rounded aria-label="Delete" />
                    </div>
                    <Button onClick={onHideDialog} className="w-2rem h-2rem" style={{ border: "1.5px solid #727A99", color: "#727A99" }} icon="pi pi-times" outlined rounded aria-label="Delete" />
                </div>
            </div>


            {step !== 4 &&
                <div className="flex w-full justify-content-center align-items-center gap-4">
                    <div className="flex gap-2 align-items-center">
                        <Badge value="1" severity="warning" style={{ backgroundColor: "#6383F4", color: "#FFFFFF" }}></Badge>
                        <p className="m-0" style={{ color: "#2D3967", whiteSpace: "nowrap" }}>{t("muscleAndJoints")}</p>
                    </div>

                    <div className="w-full" style={{ height: "1px", backgroundColor: step > 1 ? "#6383F4" : "#727A99" }}></div>
                    <div className="flex gap-2 align-items-center">
                        <Badge value="2" severity="warning" style={{ backgroundColor: step > 1 ? "#6383F4" : "#FFFFFF", color: step > 1 ? "#FFFFFF" : "#727A99", border: "1px solid #727A99" }}></Badge>
                        <p className="m-0" style={{ color: "#2D3967" }}>{t("illness")}</p>
                    </div>
                    <div className="w-full" style={{ height: "1px", backgroundColor: step > 2 ? "#6383F4" : "#727A99" }}></div>
                    <div className="flex gap-2 align-items-center">
                        <Badge value="3" severity="warning" style={{ backgroundColor: step > 2 ? "#6383F4" : "#FFFFFF", color: step > 2 ? "#FFFFFF" : "#727A99", border: "1px solid #727A99" }}></Badge>
                        <p className="m-0" style={{ color: "#2D3967" }}>{t("panels")}</p>
                    </div>
                </div>}


            <div ref={gridContainerRef} className="flex gap-3" style={{ flex: 1, minHeight: 0, overflow: "hidden", width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
                <Step1
                    selectedPatient={selectedPatient}
                    figureContainerRef={figureContainerRef}
                    setSelectedExercises={setSelectedExercises}
                    t={t}
                    step={step}
                    setManuelSelectedExercises={setManuelSelectedExercises}
                    setPanels={setPanels}
                    setActivePanelIndex={setActivePanelIndex}
                    setStep={setStep}
                    setClickedPanels={setClickedPanels}
                    selectedFigures={selectedFigures}
                    setSelectedFigures={setSelectedFigures}
                    setSelectedFiguresForFilter={setSelectedFiguresForFilter}
                    selectedIllnessList={selectedIllnessList}
                    setSelectedPanels={setSelectedPanels}
                    applyButtonVisible={applyButtonVisibleFirstStep}
                    setApplyButtonVisible={setApplyButtonVisibleFirstStep}
                    setEditedExercises={setEditedExercises}
                    />

                <Step2
                    step={step}
                    setStep={setStep}
                    selectedPanels={selectedPanels}
                    manuelSelectedExercises={manuelSelectedExercises}
                    setSelectedExercises={setSelectedExercises}
                    selectedIllnessList={selectedIllnessList}
                    setSelectedIllnessList={setSelectedIllnessList}
                    systemPanels={systemPanels}
                    applyPanelsFilter={applyPanelsFilter}
                    selectedFiguresForFilter={selectedFiguresForFilter}
                    applyButtonVisibleFirstStep={applyButtonVisibleFirstStep}
                    applyButtonVisible={applyButtonVisibleSecondStep}
                    setApplyButtonVisible={setApplyButtonVisibleSecondStep}
                    t={t}
                />

                <Step3
                    step={step}
                    setStep={setStep}
                    selectedPanels={selectedPanels}
                    setCarePlanName={setCarePlanName}
                    setSelectedPanels={setSelectedPanels}
                    selectedExercises={selectedExercises}
                    manuelSelectedExercises={manuelSelectedExercises}
                    setManuelSelectedExercises={setManuelSelectedExercises}
                    activePanelIndex={activePanelIndex}
                    setActivePanelIndex={setActivePanelIndex}
                    setSelectedExercises={setSelectedExercises}
                    applyButtonVisibleSecondStep={applyButtonVisibleSecondStep}
                    applyButtonVisibleFirstStep={applyButtonVisibleFirstStep}
                    setIsEditModeActive={setIsEditModeActive}
                    carePlanName={carePlanName}
                    panels={panels}
                    editedExercises={editedExercises}
                    setEditedExercises={setEditedExercises}
                    setIsCollapsedDetails={setIsCollapsedDetails}
                    clickedPanels={clickedPanels}
                    setClickedPanels={setClickedPanels}
                    t={t}
                />

                <Step4
                    step={step}
                    setStep={setStep}
                    days={days}
                    selectedPatient={selectedPatient}
                    selectedExercises={selectedExercises}
                    setSelectedExercises={setSelectedExercises}
                    handleCarePlanName={handleCarePlanName}
                    dateOfStart={dateOfStart}
                    dateOfEnd={dateOfEnd}
                    handleDelete={deleteExerciseOverride}
                    handleDateOfStart={handleDateOfStart}
                    handleDateOfEnd={handleDateOfEnd}
                    carePlanName={carePlanName}
                    handleApprovePrescription={handleApprovePrescription}
                    isPendingAddPlan={isPendingAddPlan}
                    setExerciseVideoDialogVisible={setExerciseVideoDialogVisible}
                    setSelectedExerciseForVideo={setSelectedExerciseForVideo}
                    isEditModeActive={isEditModeActive}
                    setIsEditModeActive={setIsEditModeActive}
                    editedExercises={editedExercises}
                    setEditedExercises={setEditedExercises}
                    isCollapsedDetails={isCollapsedDetails}
                    setIsCollapsedDetails={setIsCollapsedDetails}
                    t={t}
                />
            </div>
        </div>
    )
}

export default AddExercisesWizardSection;